module.exports = __webpack_public_path__ + "img/1L1.4647034e.png";